export default __webpack_public_path__ + "static/media/b_wdt_c_4.86d80eb9.mp3";